import React from 'react';
import './StatWidget.css';

interface StatWidgetColumn {
  label: string;
  value: string;
}

interface StatWidgetProps {
  title: string;
  columns: StatWidgetColumn[];
}

// One bordered card per metric, with each time window as a column inside
// it (rather than a separate card per window) — keeps every self-view
// section the same shape regardless of whether it has one column (Shares)
// or two (Queries, Messages, Zoho Tickets Logged).
const StatWidget: React.FC<StatWidgetProps> = ({ title, columns }) => (
  <div className="stat-widget">
    <h2 className="stat-widget-title">{title}</h2>
    <div className="stat-widget-columns">
      {columns.map((col) => (
        <div className="stat-widget-column" key={col.label}>
          <div className="stat-widget-label">{col.label}</div>
          <div className="stat-widget-value">{col.value}</div>
        </div>
      ))}
    </div>
  </div>
);

export default StatWidget;
